import { createContext, useContext, useState, useCallback, ReactNode } from 'react';
import { Holding } from '@/types/portfolio';
import { Partner } from '@/hooks/usePartner';

interface PartnerContextState {
  samplePartner: Partner | null;
  sampleHoldings: Holding[];
  setSamplePartner: (partner: Partner, holdings: Holding[]) => void;
  clearSamplePartner: () => void;
}

const PartnerContext = createContext<PartnerContextState | undefined>(undefined);

export function PartnerProvider({ children }: { children: ReactNode }) {
  const [samplePartner, setSamplePartnerState] = useState<Partner | null>(null);
  const [sampleHoldings, setSampleHoldings] = useState<Holding[]>([]);

  const setSamplePartner = useCallback((partner: Partner, holdings: Holding[]) => {
    setSamplePartnerState(partner);
    setSampleHoldings(holdings);
  }, []);

  const clearSamplePartner = useCallback(() => {
    setSamplePartnerState(null);
    setSampleHoldings([]);
  }, []);

  return (
    <PartnerContext.Provider value={{ samplePartner, sampleHoldings, setSamplePartner, clearSamplePartner }}>
      {children}
    </PartnerContext.Provider>
  );
}

export function usePartnerContext() {
  const context = useContext(PartnerContext);
  if (context === undefined) {
    throw new Error('usePartnerContext must be used within a PartnerProvider');
  }
  return context;
}
